import { createFileRoute } from '@tanstack/react-router';

import FormProject from '../../components/FormProject';
import { JsonLdBreadcrumb } from '../../components/SEO';
import ScrollTopButton from '../../components/ScrollTopButton';

export const Route = createFileRoute('/tatouage/projet')({
  component: ProjetPage,
  head: () => ({
    meta: [
      {
        title: 'Projet Tatouage | Azelysse Piercing & Tattoo',
      },
      {
        name: 'description',
        content:
          'Soumettez votre projet de tatouage chez Azelysse à Égly (91). Décrivez vos idées, partagez vos inspirations et créons ensemble un design unique.',
      },
      {
        property: 'og:title',
        content: 'Projet Tatouage | Azelysse Piercing & Tattoo',
      },
      {
        property: 'og:description',
        content:
          'Soumettez votre projet de tatouage chez Azelysse à Égly (91). Décrivez vos idées et créons ensemble un design unique.',
      },
      {
        property: 'og:url',
        content: 'https://azelysse.fr/tatouage/projet',
      },
    ],
    links: [{ rel: 'canonical', href: 'https://azelysse.fr/tatouage/projet' }],
  }),
});

function ProjetPage() {
  return (
    <div className="min-h-screen bg-linear-to-b from-emerald-50 to-white">
      <JsonLdBreadcrumb
        items={[
          { name: 'Accueil', path: '/' },
          { name: 'Tatouage', path: '/tatouage' },
          { name: 'Projet', path: '/tatouage/projet' },
        ]}
      />
      <div className="relative isolate overflow-hidden">
        <div
          className="absolute top-10 left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:top-[calc(50%-30rem)] lg:left-48 xl:left-[calc(50%-24rem)]"
          aria-hidden="true"
        >
          <div
            className="aspect-1108/632 w-277 bg-linear-to-r from-emerald-400 to-emerald-600 opacity-20"
            style={{
              clipPath:
                'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
            }}
          />
        </div>
        <div className="mx-auto max-w-4xl px-6 pt-16 pb-24 text-center lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight text-black sm:text-6xl">
            Votre futur tatouage
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-800">
            Parlez-moi de vos idées, de vos envies et de votre style. Chaque étape m'aide à
            concevoir un tatouage unique, à votre image.
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="relative z-20 mx-auto max-w-4xl px-6 py-16 lg:px-8">
        <FormProject />
      </div>

      <ScrollTopButton />
    </div>
  );
}
